module.exports = XLSX;


//////////////////
// WEBPACK FOOTER
// external "XLSX"
// module id = 250
// module chunks = 385